import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useTabs, { TabConfig, UseTabsReturn } from '@cas/components/tabs/tabs/useTabs';
import { Control, FieldValues, UseFormResetField } from 'react-hook-form';
import { useAppSelector } from '@casops/store/hooks';
import GeneralControls from '../general/GeneralControls';
import RulesControls from '../rules/RulesControls';
import InputOutputControls from '../input-output/InputOutputControls';
import { GeofenceFormModel } from '@casops/store/apis/geofencesApi';
import { getFormTabActiveView } from '@casops/side-panels/utils';

export interface UseGeofenceFormTabsProps<TFormValues extends FieldValues> {
  control: Control<TFormValues, unknown, TFormValues>;
  resetField: UseFormResetField<TFormValues>;
  isReadonly?: boolean;
}

export const useGeofenceFormTabs = (
  props: UseGeofenceFormTabsProps<GeofenceFormModel>,
): UseTabsReturn => {
  const { t } = useTranslation();

  const sidePanelTab = useAppSelector(state => state.global.sidePanelTab);

  const tabConfigs = useMemo<TabConfig[]>(() => {
    return [
      {
        title: t('Navigation.General'),
        view: <GeneralControls {...props} />,
        isDotted: false,
      },
      {
        title: t('Navigation.Rules'),
        view: <RulesControls {...props} />,
        isDotted: false,
      },
      {
        title: t('Navigation.InputOutput'),
        view: <InputOutputControls {...props} />,
        isDotted: false,
      },
    ];
  }, [t, props]);

  return useTabs({
    tabConfigs,
    defaultTab: sidePanelTab,
    getActiveView: getFormTabActiveView,
  });
};

export default useGeofenceFormTabs;
